/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./header.vue?vue&type=template&id=2d40c520&"
import script from "./header.vue?vue&type=script&setup=true&lang=ts&"
export * from "./header.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports